import { enableProdMode} from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { AuthConfig,WecheerAmplifyModule } from 'wecheer-amplify';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

WecheerAmplifyModule.configureCognito(new AuthConfig(
  environment.baseUrl,
  environment.authUrl,
  environment.clientId,
  environment.region,
  environment.userPoolId
));

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
